var map = {
	"./awaiting_delivery-icon.svg": 19508,
	"./awaiting_store_confirmation-icon.svg": 27480,
	"./canceled-icon.svg": 79016,
	"./closed-icon.svg": 36223,
	"./delivered-icon.svg": 71660,
	"./in_return-icon.svg": 48602,
	"./in_return_courier-icon.svg": 31951,
	"./in_source_preparation-icon.svg": 57743,
	"./in_transit-icon.svg": 24373,
	"./pending_package-icon.svg": 3403,
	"./pickup-icon.svg": 8677,
	"./ready_for_pickup-icon.svg": 49590,
	"./rescheduled-icon.svg": 69144,
	"./return_in_review-icon.svg": 93141,
	"./returned-icon.svg": 95444
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10762;